<template>
  <div class="feedBack">
    <!--顶部导航-->
    <Navbar title="意见反馈" />
    <!--内容区域-->
    <div class="content">
      <!--意见反馈表单-->
      <div class="feedback-form">
        <div class="form-item">
          <div class="label">
            <img src="@/assets/style/contactInfo-icon.png" alt="" />
            <span>问题描述</span>
          </div>
          <textarea
            maxlength="200"
            show-word-limit
            auto-height
            auto-size
            @input="handleInput"
            v-model="feedBackValue"
            class="feedback-input"
            placeholder="请输入您的意见反馈"
          ></textarea>
        </div>
        <div class="tip-length">
          <span>（{{ feedBackValue.length }}/200）</span>
        </div>
      </div>
      <!--提交按钮-->
      <div class="submit-btn" :class="{'disabled': disabled}" @click="handleSubmit">
        <div>提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import { submitFeedback } from "@/api/index.js";

export default {
  name: "FeedBack",
  components: {
    Navbar,
  },
  data() {
    return {
      feedBackValue: "",
    };
  },
  async mounted() {},
  methods: {
    handleInput(val) {
      this.feedBackValue = val.target.value;
    },
    //提交反馈
    async handleSubmit() {
      if (this.disabled) {
        return;
      }
      const res = await submitFeedback({
        content: this.feedBackValue,
      });
      if (res.code === 2000) {
        this.$toast("提交成功");
        this.feedBackValue = "";
        this.$router.back();
      } else {
        this.$toast(res.msg || res.message || "提交失败");
      }
    }
  },
  computed: {
    disabled() {
      return this.feedBackValue.length === 0;
    }
  },
};
</script>

<style scoped lang="scss">
.feedBack {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #f4f4f4;
  background-size: 100% 30%;
  background-repeat: no-repeat;
}
.content {
  padding: 16px;
}
.feedback-form {
  padding: 16px;
  background: #fff;
  border-radius: 10px;
  min-height: 302px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  img {
    width: 8px;
    height: 8px;
    margin-right: 8px;
  }
  span {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
  }
}
.feedback-input {
  width: 100%;
  border: none;
  outline: none;
  height: 270px;
  font-size: 16px;
}
.tip-length {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 12px;
  color: #777777;
}
.submit-btn{
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    background: #F24334;
    border-radius: 30px;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
}
.disabled {
  background: #FFC2BD;
}
</style>
